import { UploadMediaReportRepository } from "../../../domain/upload-media-report-repository";
import { Injectable } from "@angular/core";
import { HttpService } from "../../http/http";
import {
  SQCCRecord,
  UploadMediaReportItem,
} from "../../../domain/upload-media-report-item";
import moment from "moment";
import { UploadService } from "../../upload/upload-service";
import { IUploadFile } from "../../../domain/Upload/i-upload-file";

@Injectable()
export class UploadMediaReportRepositoryImpl
  implements UploadMediaReportRepository
{
  constructor(
    private httpService: HttpService,
    private uploadService: UploadService,
  ) {}

  get(offset, limit, searchQuery, orderBy, sortBy) {
    let orderByEnum;
    switch (orderBy) {
      case "date":
        orderByEnum = 2;
        break;
      case "filename":
      default:
        orderByEnum = 1;
        break;
    }
    const sortByEnum = sortBy === "asc" ? 1 : 2;

    return this.httpService
      .get(
        `mediaUploadReport?Query=${searchQuery}&Limit=${limit}&Offset=${offset}&orderBy=${orderByEnum}&sortBy=${sortByEnum}`,
      )
      .then((response) => {
        let reportItems = response.items.map((item) => {
          const date = moment(item.date);
          const filename = item.filename;
          const status = item.status;
          const quality = item.quality;
          const mediaId = item.mediaId;
          const tenantUniqueId = item.tenantUniqueId;
          return new UploadMediaReportItem(
            mediaId,
            filename,
            tenantUniqueId,
            date,
            status,
            quality,
          );
        });

        const currentUploadedItems = this.getCurrentUploadedItems();
        reportItems = currentUploadedItems.concat(reportItems);
        return { total: response.total, items: reportItems };
      });
  }

  async getMediaQCCReports(mediaId: number) {
    const dbRecords = await this.httpService.get(
      `mediaUploadReport/qcc?MediaId=${mediaId}`,
    );
    return dbRecords.map(
      (x) =>
        new SQCCRecord(
          x.id,
          x.severity,
          moment.duration(x.startTime),
          moment.duration(x.endTime),
          x.issueType,
          x.description,
          x.snapshot,
          x.approved,
        ),
    );
  }

  approveMediaQccRecords(mediaId: number, ids: string[]) {
    return this.httpService.post("mediaUploadReport/set-approved-qcc-records", {
      MediaId: mediaId,
      Ids: ids,
    });
  }

  private getCurrentUploadedItems() {
    const items = [];
    this.uploadService.getUploadedMediaFiles().map((item: IUploadFile) => {
      console.log("getCurrentUploadedItems", item);
      const info = item.isError
        ? "Failed to upload"
        : "Uploading: " + Math.floor(item.progress * 100) + "%";
      items.push(
        new UploadMediaReportItem(
          -1,
          item.file.name,
          "",
          moment(item.createdDate),
          info,
          0,
        ),
      );
    });
    return items;
  }
}
